export function setGoogleTranslateUrl($elements) {
    if ($elements.length < 1) {
        return;
    }

    const navLang = navigator.language ? (navigator.language).slice(0, 2) : 'en',
          currentSite = window.location.href,
          urlTemplate = `https://translate.google.com/translate?js=n&sl=auto&tl=${navLang}&u=${currentSite}`;
    
    $elements.attr('href', urlTemplate);
}